import React from 'react';
import "./style.css";
const About = () => {
    return (
        <div className='Container'>
            {/* <h2>About US</h2> */}
            <div className='BannerAbt'>
                <h2>About Us</h2>
            </div>

            <p style={{ textAlign: 'center' }}>Welcome to Ganpati Traders , your one-stop destination for high-quality, reliable, trend-forward products that enhance your lifestyle. Whether you're here to discover new favorites or just browsing for inspiration, we're excited to share our story, vision, and what makes Ganpati Traders truly special.</p>
            <h3>Our Story</h3>
            <p style={{ textAlign: 'center' }}>Ganpati Traders was born out of a simple idea — to make online shopping easier, more reliable, and genuinely enjoyable for everyone. We noticed how challenging it had become for everyday shoppers to find products that fit their needs and meet high standards of quality and affordability. So, we decided to bridge that gap by creating a platform that brings together curated selections and exceptional customer care.
                <br /><br />  From humble beginnings with a small team and big dreams, Ganpati Traders has grown into a trusted online brand with a rapidly expanding community of happy customers. Our journey has been fueled by passion, persistence, and a strong belief in doing business correctly — with transparency, integrity, and a customer-first attitude.
            </p>
            <h3>What We Offer</h3>
            <p style={{ textAlign: 'center' }}>At Ganpati Traders , we offer various products across categories to match your lifestyle and preferences. Whether you're looking for essentials or something unique, we're committed to delivering exactly what you need. Our collections are carefully designed, sourced from trusted suppliers, and regularly updated to reflect the latest trends and technologies.
                <br /> <strong>We focus on:</strong>
            </p>
            <div className='grid1'>
                <div className='Div1'>
                    <h4>Product Quality</h4>
                    <p style={{ textAlign: 'center' }}>Every product on our website is handpicked, tested, and verified to ensure it meets our quality standards.</p>
                </div>
                <div className='Div1'>
                    <h4>Affordability</h4>
                    <p style={{ textAlign: 'center' }}>Great products shouldn't break the bank. That's why we strive to keep our prices competitive without compromising quality.</p>
                </div>
                <div className='Div1'>
                    <h4>Variety </h4>
                    <p style={{ textAlign: 'center' }}>With a growing range of categories and designs, there's something for everyone on Ganpati Traders  .</p>
                </div>
                <div className='Div1'>
                    <h4>Customer Satisfaction </h4>
                    <p style={{ textAlign: 'center' }}>Your happiness is our success. We go the extra mile to ensure every interaction you have with us is smooth and positive.</p>
                </div>
            </div>
            <h3>Our Mission</h3>
            <p style={{ textAlign: 'center' }}>Our mission is simple: to bring a hassle-free and trustworthy shopping experience to every Indian household. We're not just here to sell products — we're here to solve problems, inspire confidence, and add value to your life. That means better service, faster deliveries, easier returns, and a brand you can rely on.</p>
            <h3>Our Vision</h3>
            <p style={{ textAlign: 'center' }}>We aim to be one of India's most customer-friendly e-commerce brands — where people shop not just because they need something but because they enjoy the experience. With innovation, responsiveness, and a deep understanding of what customers want, we are working to build a business that lasts for decades.</p>
            <h3>Why Choose SignSky?</h3>
            <p style={{ textAlign: 'center' }}>There are hundreds of online stores out there, but here's what sets us apart:</p>
            <div className='grid1'>
                <div className='Div2'>
                    <div>

                        <h4>Customer-First Approach</h4>
                        <p style={{ textAlign: 'center' }}>We treat our customers like family. Every order, every message, and every review matters to us. We listen, respond, and improve because your trust means everything.</p>

                    </div>
                </div>
                <div className='Div2'>
                    <div>
                        <h4>Transparency & Trust</h4>
                        <p style={{ textAlign: 'center' }}>From product descriptions to delivery timelines, we keep everything transparent and honest. No hidden costs, no surprises — just good service.</p>
                    </div>
                </div>
                <div className='Div2'>
                    <div>
                        <h4>Reliable Delivery </h4>
                        <p style={{ textAlign: 'center' }}>We partner with trusted logistics companies to ensure your orders' timely and safe delivery. Whether in a metro city or a remote town, we strive to reach you.</p>
                    </div>
                </div>
                <div className='Div2'>
                    <div>
                        <h4>Flexible Policies </h4>
                        <p style={{ textAlign: 'center' }}>Our Return & Refund Policy is designed to protect your purchase and give you peace of mind. If you are unsatisfied, we'll work with you to make it right.</p>
                    </div>
                </div>
                <div className='Div2'>
                    <div>
                        <h4>Constant Innovation</h4>
                        <p style={{ textAlign: 'center' }}>We're always looking for new ways to make your experience better. From expanding our product line to upgrading our tech and logistics, innovation is in our DNA.</p>
                    </div>
                </div>
            </div>

            <h3>Behind the Scenes</h3>
            <p style={{ textAlign: 'center' }}>Our team is made up of passionate individuals who love what they do. From sourcing products to designing web experiences and managing customer support — every department plays a crucial role in bringing Ganpati Traders to life.
                <br />We work in a collaborative, fast-paced environment where creativity and feedback are welcomed. Our culture is built on mutual respect, accountability, and the drive to improve continuously.
            </p>
            <h3>Sustainability and Ethics</h3>
            <p style={{ textAlign: 'center' }}>We care about the world we live in. At Ganpati Traders , we are gradually adopting practices that are mindful of the environment and ethical. Whether choosing eco-friendly packaging or supporting vendors with fair practices, we're committed to making a positive impact.</p>
            <h3>Community and Support</h3>
            <p style={{ textAlign: 'center' }}>We're more than just a store — we're a community. Through blogs, newsletters, and social platforms, we love engaging with our customers, sharing ideas, and creating a space where everyone feels welcome.
                <br />Our customer support team is always available to answer your questions, solve issues, and make your shopping journey as smooth as possible.
            </p>

            <div className='connect'>
                <div onClick={()=>window.open('tel:8209393590')}>
                <strong>📞</strong>
                <p><b> Phone</b></p>
                <p>8209393590</p>
                </div>
                <div onClick={()=>window.open('mailto:info@ganpatitraders.online')}>
                    <strong>📧</strong>
                <p><b> Email</b></p>
                <p>info@ganpatitraders.online</p>
                </div>
                <div>
                    <strong>💬</strong>
                <p><b> Chat</b></p>
                <p>Available 24/7 on our website</p>
                </div>
            </div>
            <h3>Looking Ahead</h3>
            <p style={{ textAlign: 'center' }}>The journey doesn't stop here. We're constantly evolving — adding more products, improving service, and introducing new features that make shopping with Ganpati Traders even better. We're working on launching our mobile app soon, expanding our reach across India, and introducing new categories based on customer requests.
                <br />As we progress, one thing remains the same: our commitment to YOU — our customers. Everything we do is centered around your needs, and we're honored to be a part of your life.
            </p>
            <h3>Thank You for Being Here</h3>
            <p style={{ textAlign: 'center' }}>Whether you're a first-time visitor or a returning customer, we thank you for choosing Ganpati Traders  . Your support helps us grow, innovate, and stay motivated. We promise to continue delivering value, convenience, and care in everything we do.</p>

        </div>
    )
}

export default About;